import { H2, Text, useGeneratePath, useStaticUrls } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { getSavedOrFirstTeamId } from 'common.components/user/selectors';

// @ts-ignore
import CreateClassButton from '../create-class-button/create-class-button';
import { SpecCourseHeader } from '../spec-course.header/header';

import './empty.scss';

export const SpecCourseEmptyContainer = () => {
    const savedOrFirstTeamId = useSelector(getSavedOrFirstTeamId);
    const generatePath = useGeneratePath();
    const { labClassSpecCourseStub } = useStaticUrls();
    const history = useHistory();

    useEffect(() => {
        if (savedOrFirstTeamId) {
            history.push(
                generatePath(labClassSpecCourseStub, { classId: savedOrFirstTeamId }) + history.location.search
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [savedOrFirstTeamId]);

    return (
        <div className="spec-course-empty">
            <SpecCourseHeader />
            <div className="spec-course-empty__wrapper">
                <H2
                    id="specCourse.emptyState.withoutTeamTitle"
                    mix="spec-course-empty__empty-title"
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}
                />
                <Text
                    className="spec-course-empty__empty-description"
                    id="specCourse.emptyState.withoutTeam"
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                />
                <CreateClassButton />
            </div>
        </div>
    );
};
